export const lifestyle = [
  { char: '🛀', name: 'Bath', nameZh: '泡澡', keywords: ['relax', 'clean', 'spa', '放鬆', '洗澡'] },
  { char: '🧖', name: 'Sauna', nameZh: '桑拿', keywords: ['spa', 'steam', 'relax', '蒸氣', '舒服'] },
  { char: '🛌', name: 'In Bed', nameZh: '睡床', keywords: ['sleep', 'rest', 'hotel', '休息', '睡覺'] },
  { char: '🚿', name: 'Shower', nameZh: '淋浴', keywords: ['wash', 'water', 'clean', '衛生'] },
  { char: '🧴', name: 'Lotion', nameZh: '乳液', keywords: ['skin', 'beauty', 'spa', '保養', '化妝品'] },
  { char: '🧼', name: 'Soap', nameZh: '肥皂', keywords: ['clean', 'wash', 'bubble', '清潔'] },
  { char: '🧽', name: 'Sponge', nameZh: '海綿', keywords: ['clean', 'wash', '海綿'] },
  { char: '🧺', name: 'Laundry', nameZh: '洗衣籃', keywords: ['clean', 'clothes', 'home', '洗衣服'] },
  { char: '🪠', name: 'Plunger', nameZh: '吸盤', keywords: ['fix', 'toilet', '工具'] },
  { char: '🪣', name: 'Bucket', nameZh: '水桶', keywords: ['water', 'clean', '水桶'] },
  { char: '🪥', name: 'Toothbrush', nameZh: '牙刷', keywords: ['clean', 'teeth', '刷牙'] },
  { char: '🪒', name: 'Razor', nameZh: '刮鬍刀', keywords: ['shave', 'hair', '整理'] },
  { char: '🧹', name: 'Broom', nameZh: '掃把', keywords: ['clean', 'home', '打掃'] },
  { char: '🕯️', name: 'Candle', nameZh: '蠟燭', keywords: ['light', 'relax', 'mood', '氛圍', '香氛'] },
  { char: '🧸', name: 'Teddy Bear', nameZh: '泰迪熊', keywords: ['toy', 'cute', 'kid', '可愛', '陪伴'] },
  { char: '🪑', name: 'Chair', nameZh: '椅子', keywords: ['furniture', 'sit', 'home', '居家'] },
  { char: '🛋️', name: 'Couch', nameZh: '沙發', keywords: ['furniture', 'relax', 'home', '懶散'] },
];